app = angular.module("seismology")

app.filter 'lb2br', ($sce)->
  (input) ->
    pat = "(\r\n|\n\r|\r|\n|&#10;&#13;|&#13;&#10;|&#10;|&#13;)"
    regex = new RegExp(pat, 'g')
    input.replace(regex,'<br/>').replace(/(<br\/>){3,}/,'<br/><br/>')

app.filter 'stripTags', ->
  (input) ->
    String(input).replace(/<[^>]+>/gm, '')

app.filter 'trust', ($sce)->
  (input) ->
    $sce.trustAsHtml(input)

app.filter 'ellipsis', ->
  (input, length=100) ->
    if input and input.length > length
      input.substring(0, length)+"..."
    else
      input
    
app.filter 'htmlToPlainText', ->
  (text) -> if text  then String(text).replace(/<[^>]+>/gm, '') else  ''

app.filter 'reverse', ->
  (items) -> items.slice().reverse()



// WEBPACK FOOTER //
// ./app/filters.coffee